/*
 * @Author: DT
 * @Date: 2022-10-28 11:34:03
 * @LastEditors: DT
 * @LastEditTime: 2022-11-28 14:39:16
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/address/addressList/addressList.js
 */
import { getAddressList, getDelAddress, setDefaultAddress } from "@/libs/api";
export default {
	name: "addressList",
	data() {
		return {
			chosenAddressId: "1",
			emptyFlag: false,
			result: "1",
			addressList: [],
			list: [],
			isMin:false
		};
	},
	created() {
		this.getAddressList();
		if (this.$browser().miniprogram) {
			this.isMin = true;
		}
	},
	methods: {
		getAddressList() {
			getAddressList({}, "jsonCallback").then((res) => {
				if (res.code == "0000") {
					this.addressList = res.addressList || [];
					let defAddr =
						this.addressList &&
						this.addressList.filter((item) => {
							return item.ismyprimaryaddress == "1";
						});
					if (defAddr && defAddr[0]) this.result = defAddr[0].addressId;
					console.log(this.result);
				}
			});
		},
		onDelete(addressId) {
			getDelAddress({ addressId: addressId }, "jsonCallback").then((res) => {
				if (res.code == "0000" && this.addressList) {
					this.addressList = this.addressList.filter((item) => {
						return item.addressId != addressId;
					});
					console.log(this.addressList);
					this.$toast("删除地址成功");
				}
			});
		},
		clickItem(addressId) {
			setDefaultAddress(addressId, "jsonCallback").then((res) => {
				if (res.code == "0000") {
					console.log("set def address");
					this.chosenAddressId = addressId;
				}
			});
			// this.$toast("click:" + index);
		},
		onAdd() {
			this.$toast("新增地址");
		},
		onEdit(item, index) {
			this.$toast("编辑地址:" + index);
		},
	},
};
